export default __webpack_public_path__ + "static/media/krud-kutter-automotive.928f59ee.jpeg";